import React, { useEffect, useState } from 'react';
import { List, Card, Spin, message, Typography, Tag, Row, Col } from 'antd';
import { DollarCircleOutlined, CheckCircleTwoTone, ClockCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_BASE_URL } from '../../../utils/BaseUrl';

const { Title, Text } = Typography;

const UserPaymentOrders = ({ userId }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem('user')).userId;
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/PaymentOrder/user/${user}`);
        setOrders(res.data);
      } catch (error) {
        message.error('Không thể tải danh sách đơn hàng.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [userId]);

  if (loading) {
    return <Spin style={{ display: 'block', margin: '80px auto' }} />;
  }

  if (orders.length === 0) {
    return <p style={{ textAlign: 'center', marginTop: 50 }}>Không có đơn hàng nào.</p>;
  }

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <Title level={3} style={{ color: '#FF9800', textAlign: 'center', marginBottom: 32 }}>
        Lịch sử đơn hàng thanh toán
      </Title>

      <List
        grid={{ gutter: 24, column: 2 }}
        dataSource={orders}
        renderItem={(order) => (
          <List.Item>
            <Card
              title={
                <span>
                  <DollarCircleOutlined style={{ color: '#F15637', marginRight: 8 }} />
                  <Text strong style={{ fontSize: 18 }}>Mã đơn: {order.orderCode}</Text>
                </span>
              }
              bordered={false}
              style={{
                borderRadius: 18,
                boxShadow: '0 4px 24px #ff980033',
                minHeight: 220,
                background: order.status === 'Paid'
                  ? 'linear-gradient(135deg, #e8f5e9 0%, #fffbe7 100%)'
                  : '#fffbeee6'
              }}
              headStyle={{ borderRadius: '18px 18px 0 0' }}
            >
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <Text strong>Tên người dùng:</Text> {order.userName}
                </Col>
                <Col span={24}>
                  <Text strong>Gói:</Text> {order.packageName}
                </Col>
                <Col span={24}>
                  <Text strong>Số tiền:</Text>{' '}
                  <span style={{ color: '#d32f2f', fontWeight: 700, fontSize: 18 }}>
                    {order.amount.toLocaleString()} VNĐ
                  </span>
                </Col>
                <Col span={24}>
                  <Text strong>Ngày tạo:</Text>{' '}
                  <ClockCircleOutlined style={{ color: '#388e3c', marginRight: 4 }} />
                  {new Date(order.createdAt).toLocaleString()}
                </Col>
                <Col span={24}>
                  <Text strong>Trạng thái:</Text>{' '}
                  <Tag
                    color={order.status === 'Paid' ? 'green' : 'orange'}
                    icon={order.status === 'Paid'
                      ? <CheckCircleTwoTone twoToneColor="#52c41a" />
                      : <ClockCircleOutlined />}
                    style={{ fontWeight: 600, fontSize: 15 }}
                  >
                    {order.status === 'Paid' ? 'Đã thanh toán' : 'Chờ thanh toán'}
                  </Tag>
                </Col>
              </Row>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default UserPaymentOrders;
